import React, { useState } from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";
import InputFieldDataProfile from "../../../components/InputFieldDataProfile";
import { Box, Button } from '@mui/material';
import { alpha } from "@mui/material/styles"
import { red } from '@mui/material/colors';
import { passwordSchema } from "../../../validations/passwordValidation";
import { useResetPasswordAppMutation } from '../../../services/accountsApi';

export default function ChangePassword() {
  const [loader, setLoader] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState([]);
  const [initResetPasswordApp, {isLoading: resetPasswordAppIsLoading}] = useResetPasswordAppMutation();

  const [Password, setPassword] = useState({
    value: "",
    error: false,
  });
  const [ConfirmPassword, setConfirmPassword] = useState({
    value: "",
    error: false,
  });
  const [OldPassword, setOldPassword] = useState({
    value: "",
    error: false,
  });

  const sendPassword = () => {
    setLoader(true);
    initResetPasswordApp({
      oldPassword: OldPassword.value,
      password: Password.value,
      confirmPassword: ConfirmPassword.value,
    })
      .unwrap()
      .then(() => {
        setLoader(false);
        setSuccess(true);

        setPassword({value: "",error: false})
        setConfirmPassword({value: "",error: false})
        setOldPassword({value: "",error: false})
      })
      .catch((e) => {
        setSuccess(false);
        setLoader(false);
        setError([e?.message ?? 'Error when changing the password on the server. Check your password.']);

        setPassword({value: "",error: false})
        setConfirmPassword({value: "",error: false})
        setOldPassword({value: "",error: false})
      });
    console.log({
      oldPassword: OldPassword.value,
      password: Password.value,
      confirmPassword: ConfirmPassword.value,
    });
  };

  const validationConfirm = async (e) => {
    try {
      await passwordSchema.validate({
        oldPassword: OldPassword.value !== "" ? OldPassword.value : null,
        password: Password.value  !== "" ? Password.value : null,
        confirmPassword: ConfirmPassword.value !== "" ? ConfirmPassword.value : null,
      });
      setError([])
    }
    catch (error) {
      if (error.name == "ValidationError") {
        setError(error.errors);
      }
    }
  };

  const isButtonDisabled = () => {
    return (error && error.length > 0) || Password.value.trim() === "" || ConfirmPassword.value.trim() === "" || OldPassword.value.trim() === "" || Password.error || ConfirmPassword.error || OldPassword.error;
  };

  const inputStyleError = (error) => {
    return [{ marginRight: "5px" }, (theme) => ({
      '& input': {
        backgroundColor: 'white !important',
        width: '250px !important'
      }
    }), (theme) => {
      if (error) {
        return ({
          '& input': {
            border: '2px solid red',
          },
          '& input:focus': {
            boxShadow: `${alpha(red[600], 1)} 0 0 0 0.1rem !important`,
            borderColor: red[600] + ' !important',
          }
        })
      }
      else {
        return ({
          '& input': {
            border: '1px solid var(--grey)',
          }
        })
      }
    }]
  }

  return (
    <Box sx={{display: 'flex', flexDirection: 'column' }}>
      <Box className="container-profile-password">
        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
          <InputFieldDataProfile
            label="Old Password"
            value={OldPassword.value}
            onChange={(e) => {
              if (!loader)
                setSuccess(false);
              setOldPassword((prev) => { return { ...prev, value: e.target.value } })
            }}
            onBlur={validationConfirm}
            onKeyUp={validationConfirm}
            inputType="password"
            edit={true}
            sx={inputStyleError(OldPassword?.error)}
          />

          <InputFieldDataProfile
            label="New Password"
            value={Password.value}
            onChange={(e) => {
              if (!loader)
                setSuccess(false);
              setPassword((prev) => { return { ...prev, value: e.target.value } })
            }}
            onBlur={validationConfirm}
            onKeyUp={validationConfirm}
            inputType="password"
            edit={true}
            sx={inputStyleError(Password?.error)}
          />

          <InputFieldDataProfile
            label="Confirm Password"
            value={ConfirmPassword.value}
            onChange={(e) => {
              if (!loader)
                setSuccess(false);
              setConfirmPassword((prev) => { return { ...prev, value: e.target.value } })
            }}
            onBlur={validationConfirm}
            onKeyUp={validationConfirm}
            inputType="password"
            edit={true}
            sx={inputStyleError(ConfirmPassword?.error)}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          {loader ? (
            <CircularProgress style={{ color: "#F29B1B" }} />
          ) : success ? (
            <span
              className=" text-decoration-none"
              disabled={isButtonDisabled()}
            >
              Your password was changed.
            </span>
          ) : (
            <Button
              variant='contained'
              style={{ margin: "0", borderRadius: '2em' }}
              onClick={sendPassword}
              disabled={isButtonDisabled()}
            >
              Change Password
            </Button>
          )}
        </Box>
      </Box>
        
      <Box sx={{ display: "flex"}}>
        {error && error.length > 0 && <ul style={{ color: 'var(--red)' }} >
          {error.map((err) => (
            <li key={err}>{err}</li>
          ))}
        </ul>}
      </Box>
    </Box>
  )
}